/*
 * article.js — Blogpost-Enhancements (WP 4.3). Dependency-free, reduced-motion-safe.
 * 1) Reading-Progress-Bar (Scroll-%)
 * 2) TOC-Scroll-Spy: baut die Einträge aus [data-toc]-Ankern, IntersectionObserver hebt den
 *    aktiven Eintrag hervor; Klick = Smooth-Scroll (-120 Offset). Mobile-TOC ist ein natives
 *    <details>-Accordion (kein JS fürs Auf/Zu); Klick im Accordion klappt es danach zu.
 * 3) Sticky-Add-Bar (Mobile): erscheint ab Scroll > ~760px, z unter Drawer/Cookie.
 * 4) Bookmark-Toggle: global via assets/wishlist.js · 4b) Web-Share-API mit Copy-Link-Fallback
 * 5) Editorial-Erfolg-Toast nach Add · 6) YouTube-Click-to-load (DSGVO-2-Klick)
 *
 * Add-to-Cart der editorial Karte / Quick-Pick / Sticky-Bar sind echte <form action=/cart/add>
 * und laufen über den globalen cart.js-Submit-Handler (AJAX + Drawer). Hier nur UI-Glue.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-article-root]');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- 1) Reading-Progress ----------
  var progressFill = document.querySelector('[data-article-progress]');
  function updateProgress() {
    if (!progressFill) return;
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    var pct = max > 0 ? Math.min(100, Math.max(0, (doc.scrollTop || window.pageYOffset) / max * 100)) : 0;
    progressFill.style.width = pct.toFixed(1) + '%';
  }

  // ---------- 2) TOC (aus [data-toc]-Ankern gebaut) ----------
  var tocList = root.querySelector('[data-article-toc-list]');
  var tocDetails = root.querySelector('[data-article-toc]');
  var anchors = Array.prototype.slice.call(root.querySelectorAll('.hm-article__main [data-toc]'));
  var links = [];

  if (tocList && anchors.length) {
    anchors.forEach(function (el, i) {
      if (!el.id) el.id = 'sec-' + (i + 1);
      var label = el.getAttribute('data-toc');
      var a = document.createElement('a');
      a.className = 'hm-article__toc-link';
      a.href = '#' + el.id;
      a.textContent = label;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var top = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 120;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        // Mobile-Accordion nach Klick wieder zuklappen
        if (tocDetails && window.matchMedia('(max-width:1024px)').matches) tocDetails.open = false;
      });
      tocList.appendChild(a);
      links.push({ link: a, target: el });
    });
  } else if (tocDetails) {
    // Keine ankerbaren Abschnitte → TOC ausblenden
    tocDetails.hidden = true;
  }

  // Scroll-Spy via IntersectionObserver (aktiven Eintrag hervorheben)
  if (links.length && 'IntersectionObserver' in window) {
    var visible = {};
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting ? entry.intersectionRatio : 0;
      });
      var bestId = null, best = -1;
      links.forEach(function (l) {
        var r = visible[l.target.id] || 0;
        if (r > best) { best = r; bestId = l.target.id; }
      });
      links.forEach(function (l) {
        l.link.classList.toggle('is-active', l.target.id === bestId && best > 0);
      });
    }, { rootMargin: '-120px 0px -55% 0px', threshold: [0, 0.25, 0.6, 1] });
    links.forEach(function (l) { spy.observe(l.target); });
  }

  // ---------- 3) Sticky-Add-Bar (Mobile, ab Scroll > 760) ----------
  // Die Bar sitzt bottom:0 als unteres Element: die Bottom-Nav rendert auf Artikel-Seiten nicht
  // (mobile-nav.liquid; F076c gelöst), deren body-padding-Reserve greift hier ebenfalls nicht
  // (body:not(.template-article)) → das Inline-Padding unten ist die einzige Platzreserve.
  var stickybar = document.querySelector('[data-article-stickybar]');
  var SHOW_AFTER = 760;
  function updateStickybar() {
    if (!stickybar) return;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var on = y > SHOW_AFTER;
    if (on && stickybar.hidden) stickybar.hidden = false;
    stickybar.classList.toggle('is-on', on);
    // Solange die (fixe) Bar sichtbar ist, unten Platz in Bar-Höhe reservieren → der Footer endet
    // darüber und wird nicht mehr überdeckt. offsetHeight = 0, wenn die Bar (z. B. per CSS) unsichtbar
    // ist, daher greift die Reserve automatisch nur dort, wo die Bar wirklich angezeigt wird
    // (inkl. safe-area, die im padding der Bar steckt und in offsetHeight enthalten ist).
    document.body.style.paddingBottom = on ? (stickybar.offsetHeight + 'px') : '';
  }

  // ---------- Gemeinsamer Scroll-Handler (passive, rAF-gedrosselt) ----------
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      updateProgress();
      updateStickybar();
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  updateProgress();
  updateStickybar();

  // ---------- 4) Bookmark (Wishlist) ----------
  // Bookmark-Toggle läuft global über assets/wishlist.js (delegierter Klick + data-wishlist-* Snapshot).

  // ---------- 4b) Share ----------
  var shareBtn = document.querySelector('[data-article-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var data = {
        title: shareBtn.getAttribute('data-share-title') || document.title,
        url: shareBtn.getAttribute('data-share-url') || window.location.href
      };
      if (navigator.share) {
        navigator.share(data).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(data.url).then(function () {
          if (window.Homedia && Homedia.cart && Homedia.cart.announce) Homedia.cart.announce(data.url);
        }).catch(function () {});
      } else {
        window.prompt(data.url, data.url);
      }
    });
  }

  // ---------- 5) Editorial-Erfolg-Toast nach Add ----------
  // cart.js feuert cart:added; zeige den Inline-Toast der Karte, deren Form gerade submittet wurde.
  var lastSubmittedCard = null;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.closest) {
      var card = form.closest('[data-editorial-product]');
      if (card) lastSubmittedCard = card;
    }
  }, true);
  document.addEventListener('cart:added', function () {
    if (!lastSubmittedCard) return;
    var toast = lastSubmittedCard.querySelector('[data-epc-toast]');
    if (toast) {
      toast.hidden = false;
      window.setTimeout(function () { toast.hidden = true; }, 6000);
    }
    lastSubmittedCard = null;
  });

  // ---------- 6) YouTube Click-to-load (DSGVO: nichts von Google lädt vor dem Klick) ----------
  // cb-youtube rendert nur ein lokales Poster; erst der Klick baut das iframe (youtube-nocookie).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-yt-play]');
    if (!btn) return;
    var wrap = btn.closest('[data-yt-embed]');
    if (!wrap) return;
    var id = wrap.getAttribute('data-yt-id');
    if (!id) return;
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0');
    iframe.setAttribute('title', btn.getAttribute('aria-label') || 'YouTube-Video');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    wrap.innerHTML = '';
    wrap.appendChild(iframe);
    iframe.focus();
  });
})();
